import React from 'react';
import MultiCheckboxFilter from '../multi-checkbox-filter/MultiCheckboxFilter';
import TagFilter from '../tag-filter/TagFilter';
import SingleCheckboxFilter from '../single-checkbox-filter/SingleCheckboxFilter';
import KeywordFilter from '../keyword-filter/KeywordFilter';
import * as FilterTypeConstants from '../../constants/filter-types';

const FilterList = ({ filters, activeFilters, filterSettings, toggleFilters, resetFilterGroup, focusedFilter, toggleFocus }) => {
    return (
        <div className='filters'>

            {filters.map((filter, index) => {
                const activeValues = getActiveValues(filter, activeFilters);
                switch (filter.type) {

                    case FilterTypeConstants.FILTER_TYPE_MULTI_CHECKBOX:
                        return (
                            <MultiCheckboxFilter
                                key={index}
                                filter={filter}
                                selectedItems={activeValues}
                                toggleFilters={toggleFilters}
                                classModifier='filter-item'
                                isFocused={focusedFilter === filter}
                                toggleFocus={toggleFocus} />
                        );

                    case FilterTypeConstants.FILTER_TYPE_SINGLE_CHECKBOX:
                        return (
                            <SingleCheckboxFilter
                                key={index}
                                filter={filter}
                                isChecked={activeValues.length ? (filter.values[0] === activeValues[0]) : false}
                                toggleFilters={toggleFilters}
                                classModifier='filter-item' />
                        );

                    case FilterTypeConstants.FILTER_TYPE_KEYWORDS:
                        return (
                            <KeywordFilter
                                key={index}
                                filter={filter}
                                keyword={activeValues.length ? activeValues[0] : ''}
                                updateKeyword={toggleFilters}
                                placeholderText={filterSettings.keywordPlaceholderText ? filterSettings.keywordPlaceholderText : 'Enter keywords'}
                                classModifier='filter-item' />
                        );

                    case FilterTypeConstants.FILTER_TYPE_TAG:
                        return (
                            <TagFilter
                                key={index}
                                filter={filter}
                                selectedItems={activeValues}
                                toggleFilters={toggleFilters}
                                resetFilterGroup={resetFilterGroup}
                                classModifier='filter-item'
                                isFocused={focusedFilter === filter}
                                toggleFocus={toggleFocus} />
                        );

                }
            })}
        </div>
    );
};

// Find the active filter values of the specific filter
function getActiveValues(filter, activeFilters) {
    for (let activeFilter of activeFilters) {
        if(activeFilter.code === filter.code) {
            return activeFilter.values;
        }
    }
    return [];
}

FilterList.propTypes = {
    filters: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    filterSettings: React.PropTypes.object.isRequired,
    activeFilters: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    toggleFilters: React.PropTypes.func,
    resetFilterGroup: React.PropTypes.func,
    focusedFilter: React.PropTypes.object,
    toggleFocus: React.PropTypes.func.isRequired
};

export default FilterList;



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/filters/filter-list/FilterList.jsx
 **/